import { PDFDocument, rgb } from "pdf-lib";
import * as fontkit from "fontkit";

export async function personalizePDF(arrayBuffer, name, results) {
  const pdfDoc = await PDFDocument.load(arrayBuffer);
  pdfDoc.registerFontkit(fontkit);

  const arialBytes = await fetch("/ARIALBD.ttf").then(res => {
    if (!res.ok) throw new Error("ARIALBD.ttf not found");
    return res.arrayBuffer();
  });
  const arialBoldBytes = await fetch("/ARIALBD.ttf").then(res => {
    if (!res.ok) throw new Error("ARIALBD.ttf not found");
    return res.arrayBuffer();
  });

  const arialFont = await pdfDoc.embedFont(arialBytes);
  const arialBoldFont = await pdfDoc.embedFont(arialBoldBytes);

  const pages = pdfDoc.getPages();

  const newName = name + ",";
  const firstPage = pages[0];

  firstPage.drawRectangle({
    x: 81,
    y: 430,
    width: 10,
    height: 30,
    color: rgb(1, 1, 1),
  });

  firstPage.drawText(newName, {
    x: 81,
    y: 438,
    size: 16,
    font: arialFont,
     color: rgb(158 / 255, 21 / 255, 47 / 255) 
  });

  const resultFontSize = 28;

  const coordinates = [
    { x: pages[1].getWidth() - 56, y: pages[1].getHeight() - 53 },
    { x: pages[2].getWidth() - 48, y: pages[2].getHeight() - 52 },
    { x: pages[3].getWidth() - 52, y: pages[3].getHeight() - 51 },
    { x: pages[4].getWidth() - 48, y: pages[4].getHeight() - 50 },
    { x: pages[5].getWidth() - 46, y: pages[5].getHeight() - 51 },
  ];

  for (let i = 1; i <= 5; i++) {
    const page = pages[i];
    const { x, y } = coordinates[i - 1];
    const value = String(results[i - 1]);
    const adjustedX = value.length === 1 ? x + 4 : x;
    const adjustedY = value.length === 1 ? y - 2 : y;
    page.drawText(value, {
      x: adjustedX,
      y: adjustedY,
      size: value.length > 1 ? 20 : resultFontSize,
      font: arialBoldFont,
      color: rgb(0, 0, 0),
    });
  }

  const modifiedPdf = await pdfDoc.save();
  return new Blob([modifiedPdf], { type: "application/pdf" });
}
